
import { ADD_NOTE ,SET_EXP_DATA, SET_EDU_DATA,SET_PROJECT_DATA, SET_SKILLS_DATA, SET_COURSES_DATA,SET_PROFILE_DATA, SET_HOBBY_DATA} from "./constants";

const initalState = {
    notes : ['first']
}
const initalPortState = {
    exp : "",
    edu: "",
    projects: "",
    skills: "",
    courses: "",
    profile: "",
    hobby:"",
}

const noteReducer = (state =initalState, action)=>{
    switch(action.type){
        case ADD_NOTE:
            return {
                ...state,
                notes: [...state.notes,action.payload]
            }

        default:
            return state
    }
}

const portfolioReducer = (state =initalPortState, action)=>{
    switch(action.type){
        case SET_EXP_DATA:
            // alert("exp");
            return {
            
                ...state,
                exp: action.payload
            }
        case SET_EDU_DATA:
            // alert(JSON.stringify(action.payload));
            return {
                ...state,
                edu: action.payload
            }
        case SET_PROJECT_DATA:
            return {
                ...state,
                projects: action.payload
            }
        case SET_SKILLS_DATA:
            return {
                ...state,
                skills: action.payload
            }
        case SET_COURSES_DATA:
            return {
                ...state,
                 courses: action.payload
             }
        case SET_PROFILE_DATA:
            return {
                ...state,
                profile: action.payload
            }

        case SET_HOBBY_DATA:
            return {
                ...state,
                hobby: action.payload
            }
        
        default:
            return state
    }
}

export default portfolioReducer;